import { render, staticRenderFns } from "./TheModal.vue?vue&type=template&id=18850f25&"
import script from "./TheModal.vue?vue&type=script&lang=js&"
export * from "./TheModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports